<div class="buttons">
  <span *ngFor="let packagePlan of plans">
    <app-package-plan-button
      [plan]="packagePlan" (onButtonClick)="onButtonClick(packagePlan)">
    </app-package-plan-button>
  </span>
</div>
